export function timeAgo(date: string | null | undefined): string {
  if (!date) return '-';
  
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

  const today = new Date(todayStr + 'T00:00:00');
  
  // Handle both ISO format (2026-01-14T10:30:00.000Z) and simple date (2026-01-14)
  let pastStr = date;
  if (date.includes('T')) {
    pastStr = date.split('T')[0];
  }
  
  const past = new Date(pastStr + 'T00:00:00');
  
  // Check for invalid date
  if (isNaN(past.getTime())) {
    return '-';
  }

  const diffMs = today.getTime() - past.getTime();
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffDays === 0) return 'hoje';
  if (diffDays === 1) return 'ontem';
  if (diffDays === -1) return 'amanhã';
  if (diffDays < 0) return `em ${Math.abs(diffDays)} dias`;
  if (diffDays < 7) return `há ${diffDays} dias`;
  if (diffDays < 30) {
    const weeks = Math.floor(diffDays / 7);
    return weeks === 1 ? 'há 1 semana' : `há ${weeks} semanas`;
  }

  const diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) return diffMonths === 1 ? 'há 1 mês' : `há ${diffMonths} meses`;

  const diffYears = Math.floor(diffDays / 365);
  return diffYears === 1 ? 'há 1 ano' : `há ${diffYears} anos`;
}
